/**
 * Nonce context — provides incrementing IDs for composition ordering.
 *
 * Written from scratch for Steve.AI.
 */

import { createContext, useContext, useEffect, useRef, useState } from 'react';

export const NonceContext = createContext({
  getNonce: () => 0,
  fastRefreshes: 0,
});

export const useNonce = () => {
  const context = useContext(NonceContext);
  const [nonce, setNonce] = useState(() => context.getNonce());
  const lastContext = useRef(context);

  useEffect(() => {
    if (lastContext.current === context) return;
    lastContext.current = context;
    setNonce(context.getNonce);
  }, [context]);

  return nonce;
};
